import React from 'react';
import { formatMoney, formatSortCode } from 'suits-me-npm/utils';
import { accountRolesLookup, currencies } from 'suits-me-npm/constants';
import useTranslate from 'suits-me-npm/languages/useTranslate';
import { useSelector } from 'react-redux';
import { getIsEuro } from 'suits-me-npm/selectors';
import { toCamelCase } from 'utils/generic';

const AccountOverview = ({
    handleShowModal,
    account: {
        accountName,
        bankAccountNo,
        sortCode,
        iban,
        clearedBalance,
        clearedBalanceCurrencyCode,
        productType,
    },
    accounts,
}) => {
    const translate = useTranslate('accountOverview');
    const isEuro = useSelector(getIsEuro);
    return (
        <div className="account-overview-container">
            <div
                className={`account-select ${
                    accounts.length ? 'multi-accounts' : ''
                }`}
                onClick={accounts.length > 1 ? e => handleShowModal(e) : null}
            >
                <div
                    className={`account-details-wrapper ${
                        accounts.length ? 'multi-accounts' : ''
                    }`}
                >
                    <p>
                        <strong>
                            {accountName || 'Unknown'} -{' '}
                            {translate(
                                toCamelCase(
                                    accountRolesLookup[productType] || '',
                                ),
                            )}
                        </strong>
                    </p>
                    {accounts.length > 1 && (
                        <i className="far fa-angle-down icon"></i>
                    )}
                </div>
                <p className="account-number">
                    {isEuro
                        ? `IBAN ${iban || translate('unknown')}`
                        : translate('accountNo', {
                              bankAccountNo:
                                  bankAccountNo || translate('unknown'),
                              sortCode:
                                  formatSortCode(sortCode) ||
                                  translate('unknown'),
                          })}
                </p>
            </div>
            <p className="amount">
                <strong>
                    {currencies[clearedBalanceCurrencyCode]}
                    {formatMoney(clearedBalance)}
                </strong>
            </p>
        </div>
    );
};

export default AccountOverview;
